import selectPatientMergeProps from '../SelectPatient/mergeProps';

const mergeProps = (stateProps, dispatchProps, ownProps) => {
    return {
        ...selectPatientMergeProps(stateProps, dispatchProps, ownProps),
        appointmentDetails: {
            ...stateProps.appointmentDetails,
            ...dispatchProps.appointmentDetails,
            ...ownProps,
        },
        onPatientSelectionSuccess: chosenPatientId => {
            dispatchProps._onPatientSelectionSuccess({
                chosenPatientId,
                bookingState: stateProps.bookingState,
            });
        },
        onPhoneVerified: () => {
            dispatchProps._onPhoneVerified(stateProps.bookingState);
        },
    };
};

export default mergeProps;
